import React, { FC } from 'react';
import { MfaMethod } from './MFAService';
import MFAMethodItem from './MFAMethodItem';

type MFAListProps = {
  methods: MfaMethod[];
  onRemove: (id: string) => void;
  disabled?: boolean;
};

const MFAList: FC<MFAListProps> = ({ methods, onRemove, disabled }) => {
  return (
    <div data-test-mfa-list>
      {methods.map(method => (
        <MFAMethodItem
          key={method.id}
          method={method}
          onRemove={onRemove}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default MFAList;
